import SimpleDialog from "./dialogs/SimpleDialog";

const NotFound = () => {
    return (
        <>
            <SimpleDialog message1="Page Not Found" message2="The current address is unavailable." />
            <hr className="mt-5" />
        </>
    );
};

export default NotFound;
